import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a6fc4c88295d5001453ebb1_1785746748827_a643dc03/mediqragent/src/app/page.tsx");
